import Icon1 from "@assets/icons/Icon";
import { colors } from "sexy";
import { useState } from "react";

interface CustomImageProps {
  source: { uri: string };
  style?: React.CSSProperties;
  className?: string;
  hidden?: boolean;
  alt?: string;
  onClick?: () => void;
}

export const CustomImage = ({
  source,
  style,
  className = "",
  hidden = false,
  alt = "",
  onClick,
}: CustomImageProps) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className={`relative ${className}`} style={style} onClick={onClick}>
      {imageError ? (
        <div
          className="w-full h-full flex items-center justify-center bg-neutral-100 rounded-xl"
          style={style}
        >
          <Icon1 name="image-off" size={32} color={colors.neutral_400} />
        </div>
      ) : (
        <>
          <img
            src={source.uri}
            alt={alt}
            className="w-full h-full object-cover rounded-xl"
            style={style}
            onError={() => setImageError(true)}
          />
          {hidden && (
            <div className="absolute inset-0 bg-black/30 rounded-xl flex items-center justify-center">
              <Icon1 name="invisible" size={24} color="white" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
